# GraphQL query to get a slack message by id

#import "../fragments/closed-lead-slack-message-fragment.graphql"

query GetClosedLeadSlackMessage($id: ID!) {
    closedLeadSlackMessage(id: $id) {
        ...ClosedLeadSlackMessage
    }
}
